import ImageBoundsWrapper from './ImageBoundsWrapper';

export default ImageBoundsWrapper;
